<template>
    <div>

        <div class="banner position-relative">
            <!-- shape Hero -->
            <section class="section-shaped my-0">
                <div class="shape shape-style-1 bg-gradient-info shape-skew">

                </div>
                <div class="container shape-container d-flex">
                    <div class="col px-0">
                        <div class="row">
                            <div class="title col-lg-6">
                                <h1 class="display-3  text-black">Ropa y Regalos
                                    <span>Personalizados</span>
                                </h1>
                                <p class="lead  text-black">
                                    Disponemos de un amplio catálogo de ropa, accesorios y regalos completamente personalizables.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <!-- 1st Hero Variation -->
        </div>
        <section class="section section-lg">
            <div class="container">
                <div class="row justify-content-center text-center mb-lg">
                    <div class="col-lg-8">
                        <h2 class="display-3">Ropa Personalizada</h2>
                        <p class="lead text-muted">La relación calidad precio de nuestros productos se encuentra en entre las mejores del mercado, además son capaces de soportar todo tipo de personalización en ellos, sin alterar ó ver algún tipo de modificación en ellos</p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6 col-lg-3 mb-5 mb-lg-0">
                        <a href="https://www.roly.es/YouRoly/34075" class="px-4">
                            <img v-lazy="'img/theme/family.jpg'"
                                 class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                                 style="width: 200px;">
                            <div class="pt-4 text-center">
                                <h5 class="title">
                                    <span class="d-block mb-1">Familia</span>
                                </h5>
                            </div>
                        </a>
                    </div>
                    <div class="col-md-6 col-lg-3 mb-5 mb-lg-0">
                        <a href="https://www.roly.es/YouRoly/34075" class="px-4">
                            <img v-lazy="'img/theme/sport.jpg'"
                                 class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                                 style="width: 200px;">
                            <div class="pt-4 text-center">
                                <h5 class="title">
                                    <span class="d-block mb-1">Deporte</span>
                                </h5>
                            </div>
                        </a>
                    </div>
                    <div class="col-md-6 col-lg-3 mb-5 mb-lg-0">
                        <a href="https://www.roly.es/YouRoly/34075" class="px-4">
                            <img v-lazy="'img/theme/work.jpg'"
                                 class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                                 style="width: 200px;">
                            <div class="pt-4 text-center">
                                <h5 class="title">
                                    <span class="d-block mb-1">Trabajo</span>
                                </h5>
                            </div>
                        </a>
                    </div>
                    <div class="col-md-6 col-lg-3 mb-5 mb-lg-0">
                        <a href="https://www.roly.es/YouRoly/34075" class="px-4">
                            <img v-lazy="'img/theme/accessories.jpg'"
                                 class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                                 style="width: 200px;">
                            <div class="pt-4 text-center">
                                <h5 class="title">
                                    <span class="d-block mb-1">Accesorios</span>
                                </h5>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </section>
        <section class="section section-lg pt-0">
            <div class="container">
                <card gradient="default"
                      no-body
                      shadow-size="lg"
                      class="border-0">
                    <div class="p-5">
                        <div class="row align-items-center">
                            <div class="col-lg-8">
                                <h3 class="text-white">Comienza a personalizar tu ropa</h3>
                            </div>
                            <div class="col-lg-3 ml-lg-auto">
                                <base-button tag="a" href="https://www.roly.es/YouRoly/34075"
                                             type="white" block size="lg">
                                    Personalizar
                                </base-button>
                            </div>
                        </div>
                    </div>
                </card>
            </div>
        </section>
        <section class="section section section-shaped my-0 overflow-hidden">
            <div class="shape shape-style-1 bg-gradient-info shape-skew">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
            <div class="container pt-lg pb-300">
                <div class="row text-center justify-content-center">
                    <div class="col-lg-10">
                        <h2 class="display-3 text-white">Regalos Personalizados</h2>
                        <p class="lead text-white">Disponemos de un amplio catálogo de regalos para cualquier tipo de eventos y poder elegir entre las diferente formas de personalización: serigrafía, estampación, bordado, sublimación, grabación láser...</p>
                    </div>
                </div>
                <div class="row row-grid mt-5">
                    <div class="col-lg-4">
                        <a href="https://x.boxpromotions.com/epages/BoxPromotions.sf?key=dise%C3%B1oypublicidad">
                        <img v-lazy="'img/theme/ceremony.jpg'"
                             class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                             style="width: 200px;">
                        <h5 class="text-white mt-3 text-center">Eventos</h5>
                        </a>
                    </div>
                    <div class="col-lg-4">
                        <a href="https://x.boxpromotions.com/epages/BoxPromotions.sf?key=dise%C3%B1oypublicidad">
                        <img v-lazy="'img/theme/company.jpg'"
                             class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                             style="width: 200px;">
                        <h5 class="text-white mt-3 text-center">Empresas</h5>
                        </a>
                    </div>
                    <div class="col-lg-4">
                        <a href="https://x.boxpromotions.com/epages/BoxPromotions.sf?key=dise%C3%B1oypublicidad">
                        <img v-lazy="'img/theme/technology.jpg'"
                             class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                             style="width: 200px;">
                        <h5 class="text-white mt-3 text-center">Tecnología</h5>
                        </a>
                    </div>
                </div>
            </div>
            <div class="container">
                <card gradient="default"
                      no-body
                      shadow-size="lg"
                      class="border-0">
                    <div class="p-5">
                        <div class="row align-items-center">
                            <div class="col-lg-8">
                                <h3 class="text-white">Busca el merjor regalo para cada ocasión</h3>
                            </div>
                            <div class="col-lg-3 ml-lg-auto">
                                <base-button tag="a" href="https://x.boxpromotions.com/epages/BoxPromotions.sf?key=dise%C3%B1oypublicidad"
                                             type="white" block size="lg">
                                    Regalos
                                </base-button>
                            </div>
                        </div>
                    </div>
                </card>
            </div>
        </section>
    </div>
</template>

<script>
    export default {
        name: "home",
        components: {}
    };
</script>
<style>
    .banner {
        background-image: url("../assets/img/banner.jpg");
        backgorund-size: cover;
        background-position: center center;
    }
    .title {
        background-color: #ffffff90;
        border-radius: 5px;
    }
</style>
